export default __webpack_public_path__ + "static/media/O-005.f20aa829.png";